import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * B3612 (Cruzamento de Médias BIAS, FML.B3612) — painel próprio, 2 linhas:
 * B36 = MA(C,3)−MA(C,6) e B612 = MA(C,6)−MA(C,12).
 * yAccessor(d) retorna { b36, b612 }.
 */
class B3612Series extends Component {
  constructor(props) {
    super(props);
    this.b36Accessor = this.b36Accessor.bind(this);
    this.b612Accessor = this.b612Accessor.bind(this);
  }
  b36Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.b36;
  }
  b612Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.b612;
  }
  render() {
    const { strokeB36, strokeB612, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.b36Accessor}
          stroke={strokeB36}
          fill="none"
        />
        <LineSeries
          yAccessor={this.b612Accessor}
          stroke={strokeB612}
          fill="none"
        />
      </g>
    );
  }
}

B3612Series.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeB36: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeB612: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

B3612Series.defaultProps = {
  strokeB36: { color: "#FFFF00" },
  strokeB612: { color: "#FF0000" },
  className: "react-stockcharts-b3612-series",
};

export default B3612Series;
